import React from 'react';
import classnames from 'classnames';
import FilterActionBar from '../../FilterActionBar';

interface IFilterBodyProps extends IBaseProps {
  filterBodyRef: React.RefObject<HTMLDivElement>;
  containerRef: React.RefObject<HTMLDivElement>;
  showAll: boolean;
  useCustomLayout: boolean;
  renderedGroups: React.ReactNode[];
  useActionBar: boolean;
  loading: boolean;
  pristine: boolean;
  hasOverflow: boolean;
  expanded: boolean;
  showStickyClose: boolean;
  innerExtraActions?: React.ReactNode;
  resetTooltip?: string;
  extraActions?: React.ReactNode;
  onConfirm: () => void;
  onReset: () => void;
  onStickyClose: () => void;
  onToggleExpand: () => void;
}

const FilterBody: React.FC<IFilterBodyProps> = (props) => {
  const {
    style,
    className,
    filterBodyRef,
    containerRef,
    showAll,
    useCustomLayout,
    renderedGroups,
    useActionBar,
    loading,
    pristine,
    hasOverflow,
    expanded,
    showStickyClose,
    innerExtraActions,
    resetTooltip,
    extraActions,
    onConfirm,
    onReset,
    onStickyClose,
    onToggleExpand,
  } = props;

  return (
    <div
      ref={filterBodyRef}
      style={style}
      className={classnames('dbi-common-filter-v3 dbi-searchbox', className, {
        'show-all': showAll,
      })}
    >
      <div ref={containerRef} className={useCustomLayout ? 'dbi-custom-filter' : 'dbi-searchbox-flex'}>
        {renderedGroups}
      </div>

      {useActionBar && (
        <FilterActionBar
          loading={loading}
          pristine={pristine}
          hasOverflow={hasOverflow}
          expanded={expanded}
          showStickyClose={showStickyClose}
          innerExtraActions={innerExtraActions}
          resetTooltip={resetTooltip}
          extraActions={extraActions}
          onConfirm={onConfirm}
          onReset={onReset}
          onStickyClose={onStickyClose}
          onToggleExpand={onToggleExpand}
        />
      )}
    </div>
  );
};

export default FilterBody;
